import { render, staticRenderFns } from "./RelatedUsers.vue?vue&type=template&id=cef358ce"
import script from "./RelatedUsers.vue?vue&type=script&lang=js"
export * from "./RelatedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports